import React from 'react';
import { CSSProperties } from 'styled-components';
import * as S from './styles';
type Props = {
  severity: 'error' | 'warning' | 'info' | 'success';
  title?: string;
  description?: string | React.ReactNode;
  children?: any;
  style?: CSSProperties;
  className?: string;
  buttonContent?: React.ReactNode | string;
  buttonHandler?: React.MouseEventHandler;
  warningPayment?: boolean;
  variant?: 'page' | 'card';
  dense?: boolean;
};
const Alert: React.FC<Props> = ({
  severity,
  title,
  description,
  children,
  style,
  className,
  buttonContent,
  buttonHandler,
  warningPayment,
  variant = 'card',
  dense
}) => {
  return <S.Container warningPayment={warningPayment} severity={severity} style={style} variant={variant} className={className} dense={dense}>
      <S.Content dense={dense}>
        {severity === 'error' && <S.ErrorIcon variant={variant} severity={severity} dense={dense} />}
        {severity === 'warning' && <S.WarningIcon warningPayment={warningPayment} variant={variant} severity={severity} dense={dense} />}
        {severity === 'info' && <S.InfoIcon variant={variant} severity={severity} dense={dense} />}
        {severity === 'success' && <S.SuccessIcon variant={variant} severity={severity} dense={dense} />}

        {title && <S.Title warningPayment={warningPayment} variant={variant}>
            {title}
          </S.Title>}
        {description && <S.Description warningPayment={warningPayment} variant={variant}>
            {description || ''}
          </S.Description>}
        {children && children}
      </S.Content>
      {buttonHandler && <S.ButtonContainer>
          <S.Button onClick={buttonHandler} size="medium" variant="outlined">
            {buttonContent}
          </S.Button>
        </S.ButtonContainer>}
    </S.Container>;
};
export default Alert;